export const titleDetailBaseConfig = {
    displayPositionPiecesQuantity: false,
    applyDirectUrlToTitleDetails: false,
    formatStockExchangeValue: false,
    showCapitalGainsTax: false,
    findMatchingHeldTitles: false,
};
